<template>
    <div class="col-md-12">
        <div class="h2">Configuration</div>
        <div class="h5">Customer journey customization</div>
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>

        <div class="mt-5">
            <table class="table table-bordered table-striped" aria-label="Configuration table">
                <thead>
                    <tr>
                        <th style="width: 34%; font-size: 1.35rem;">VARIABLE</th>
                        <th style="width: 33%; font-size: 1.35rem;">{{ bookingNameFlex }}</th>
                        <th style="width: 33%; font-size: 1.35rem;">{{ bookingNameAdHoc }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Default time (time)</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center mb-2" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <div>
                                        <vue-timepicker
                                            manual-input
                                            placeholder="From"
                                            v-model="configurations[bookingType][`default_time_from${addressType['postfix']}`]"
                                            input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                        </vue-timepicker>
                                        <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.default_time_from${addressType['postfix']}`]">
                                            {{ errors[`configurations.${bookingType}.default_time_from${addressType['postfix']}`][0] }}
                                        </div>
                                    </div>
                                    <span class="mx-3">&mdash;</span>
                                    <div>
                                        <vue-timepicker
                                            manual-input
                                            placeholder="To"
                                            v-model="configurations[bookingType][`default_time_to${addressType['postfix']}`]"
                                            input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                        </vue-timepicker>
                                        <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.default_time_to${addressType['postfix']}`]">
                                            {{ errors[`configurations.${bookingType}.default_time_to${addressType['postfix']}`][0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Storage costs (per day - DKK)</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center">
                                <div class="address-type-label bold-font">Dropoff</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <input
                                        class="form-control small-input"
                                        type="text"
                                        v-model="configurations[bookingType].storage_cost"
                                    >
                                    <span class="ml-2">kr.</span>
                                </div>
                            </div>
                            <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.storage_cost`]">
                                {{ errors[`configurations.${bookingType}.storage_cost`][0] }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Pickup cost for changed date (per day - DKK)</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center">
                                <div class="address-type-label bold-font">Pickup</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <input
                                        class="form-control small-input"
                                        type="text"
                                        v-model="configurations[bookingType].pickup_cost_for_changed_date"
                                    >
                                    <span class="ml-2">kr.</span>
                                </div>
                            </div>
                            <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.pickup_cost_for_changed_date`]">
                                {{ errors[`configurations.${bookingType}.pickup_cost_for_changed_date`][0] }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Change address</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center mb-2" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <input
                                            class="form-control small-input"
                                            type="text"
                                            v-model="configurations[bookingType][`change_address${addressType['postfix']}`]"
                                        >
                                        <span class="ml-2">kr.</span>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}change_address${addressType['postfix']}`]">
                                        {{ errors[`configurations.${bookingType}.change_address${addressType['postfix']}`][0] }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Converting to a shorter time interval (price (DKK))</td>
                        <td v-for="bookingType in bookingTypes" class="vertical-align-top">
                            <div v-for="(addressType, addressTypeIndex) in addressTypes" class="mb-4">
                                <div class="mb-2 bold-font">{{ addressType['label'] }}</div>
                                <div v-for="(shorter_time_interval, index) in configurations[bookingType][`shorter_time_intervals${addressType['postfix']}`]">
                                    <div class="d-flex align-items-center justify-content-between mb-1">
                                        <div class="mr-1" style="width: 30%;">
                                            <vue-timepicker
                                                manual-input
                                                placeholder="From"
                                                hide-clear-button
                                                v-model="configurations[bookingType][`shorter_time_intervals${addressType['postfix']}`][index]['from']"
                                                input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                            </vue-timepicker>
                                        </div>
                                        <div class="mr-1">
                                            <vue-timepicker
                                                manual-input
                                                placeholder="To"
                                                hide-clear-button
                                                v-model="configurations[bookingType][`shorter_time_intervals${addressType['postfix']}`][index]['to']"
                                                input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                            </vue-timepicker>
                                        </div>
                                        <div class="mr-1">
                                            <div class="d-flex align-items-center justify-content-center">
                                                <input
                                                    class="form-control small-input"
                                                    type="text"
                                                    id="shorter-time-interval-before-12"
                                                    placeholder="Price"
                                                    v-model="configurations[bookingType][`shorter_time_intervals${addressType['postfix']}`][index]['price']"
                                                >
                                                <span class="ml-2">kr.</span>
                                            </div>
                                        </div>
                                        <div>
                                            <span class="material-icons-outlined text-primary cursor-pointer"
                                                  title="Remove"
                                                  @click="removeShorterTimeInterval(bookingType, index, addressTypeIndex)"
                                            >delete</span>
                                        </div>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.price`]">
                                        {{ errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.price`][0] }}
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.from`]">
                                        {{ errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.from`][0] }}
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.to`]">
                                        {{ errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.to`][0] }}
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <span class="material-icons-outlined text-primary cursor-pointer"
                                          title="Add"
                                          @click="addShorterTimeInterval(bookingType, addressTypeIndex)"
                                    >add_circle</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>SMS-flow price increase by time of day (%)</td>
                        <td v-for="bookingType in bookingTypes" class="vertical-align-top">
                            <div v-for="(addressType, addressTypeIndex) in addressTypes" class="mb-4">
                                <div class="mb-2 bold-font">{{ addressType['label'] }}</div>
                                <div v-for="(sms_flow_price_interval, index) in configurations[bookingType][`sms_flow_price_intervals${addressType['postfix']}`]">
                                    <div class="d-flex align-items-center justify-content-between mb-1">
                                        <div class="mr-1" style="width: 30%;">
                                            <vue-timepicker
                                                manual-input
                                                placeholder="From"
                                                hide-clear-button
                                                v-model="configurations[bookingType][`sms_flow_price_intervals${addressType['postfix']}`][index]['from']"
                                                input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                            </vue-timepicker>
                                        </div>
                                        <div class="mr-1">
                                            <vue-timepicker
                                                manual-input
                                                placeholder="To"
                                                hide-clear-button
                                                v-model="configurations[bookingType][`sms_flow_price_intervals${addressType['postfix']}`][index]['to']"
                                                input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                            </vue-timepicker>
                                        </div>
                                        <div class="mr-1">
                                            <div class="d-flex align-items-center justify-content-center">
                                                <input
                                                    class="form-control small-input"
                                                    type="text"
                                                    placeholder="Percentage"
                                                    v-model="configurations[bookingType][`sms_flow_price_intervals${addressType['postfix']}`][index]['percentage']"
                                                >
                                                <span class="ml-2">%</span>
                                            </div>
                                        </div>
                                        <div>
                                            <span class="material-icons-outlined text-primary cursor-pointer"
                                                  title="Remove"
                                                  @click="removeSmsFlowPriceInterval(bookingType, index, addressTypeIndex)"
                                            >delete</span>
                                        </div>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.sms_flow_price_intervals${addressType['postfix']}.${index}.percentage`]">
                                        {{ errors[`configurations.${bookingType}.sms_flow_price_intervals${addressType['postfix']}.${index}.percentage`][0] }}
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.sms_flow_price_intervals${addressType['postfix']}.${index}.from`]">
                                        {{ errors[`configurations.${bookingType}.sms_flow_price_intervals${addressType['postfix']}.${index}.from`][0] }}
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.sms_flow_price_intervals${addressType['postfix']}.${index}.to`]">
                                        {{ errors[`configurations.${bookingType}.sms_flow_price_intervals${addressType['postfix']}.${index}.to`][0] }}
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <span class="material-icons-outlined text-primary cursor-pointer"
                                          title="Add"
                                          @click="addSmsFlowPriceInterval(bookingType, addressTypeIndex)"
                                    >add_circle</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Fuldmagt (options)</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="mb-2 bold-font">Dropoff</div>
                            <div class="d-flex align-items-center justify-content-center">
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="configurations[bookingType].permits"
                                >
                            </div>
                            <div class="mb-1"><i>Separate option via <strong>;</strong></i></div>
                        </td>
                    </tr>
                    <tr>
                        <td>SMS-flow cut-off time</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex mb-2" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font mr-4">{{ addressType['label'] }}</div>
                                <div class="flex-grow-1">
                                    <div class="d-flex justify-content-between">
                                        <div>Delivery date</div>
                                        <div class="align-items-center bg-white border rounded-lg div-focus mb-2" style="width: 70%">
                                            <v-select
                                                :options="[
                                                {name: today, label: today},
                                                {name: tomorrow, label: tomorrow},
                                                {name: dayAfterTomorrow, label: dayAfterTomorrow}
                                            ]"
                                                :clearable="false"
                                                @input="changeOption"
                                                v-model="configurations[bookingType][`sms_flow_cut_off_day${addressType['postfix']}`]"
                                            >
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.sms_flow_cut_off_day${addressType['postfix']}`]">
                                        {{ errors[`configurations.${bookingType}.sms_flow_cut_off_day${addressType['postfix']}`][0] }}
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div>Cut-off at</div>
                                        <div class="mr-1">
                                            <vue-timepicker
                                                manual-input
                                                placeholder=""
                                                v-model="configurations[bookingType][`sms_flow_cut_off_time${addressType['postfix']}`]"
                                                input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                            </vue-timepicker>
                                            <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.sms_flow_cut_off_time${addressType['postfix']}`]">
                                                {{ errors[`configurations.${bookingType}.sms_flow_cut_off_time${addressType['postfix']}`][0] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Send sms on test phone number</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center justify-content-center mb-4"
                                 v-for="addressType in addressTypes"
                            >
                                <div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="mr-3 bold-font">{{ addressType['label'] }}</div>
                                        <input type="checkbox"
                                               class="form-control"
                                               style="width: 16px;"
                                               v-model="configurations[bookingType][`send_sms_on_test_number${addressType['postfix']}`]"
                                        >
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.send_sms_on_test_number${addressType['postfix']}`]">
                                        {{ errors[`configurations.${bookingType}.send_sms_on_test_number${addressType['postfix']}`][0] }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Days NOT available as delivery for customers</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="mb-2">
                                <button type="button" class="btn btn-primary" @click="clearDates($event, bookingType)">
                                    Clear all
                                </button>
                            </div>
                            <div style="width: fit-content; margin: auto;">
                                <date-picker
                                    :clearable="false"
                                    :multiple="true"
                                    :editable="false"
                                    input-class="content"
                                    valueType="DD-MM-YYYY"
                                    v-model="configurations[bookingType]['not_available_delivery_dates']"
                                    :inline="true"
                                    :lang="datePickerOptions.lang"
                                    :disabled-date="disabledDates"
                                    @change="onDateChange($event, bookingType)">
                                    <template v-slot:icon-clear>
                                        <svg></svg>
                                    </template>
                                    <template v-slot:icon-calendar>
                                        <svg></svg>
                                    </template>
                                </date-picker>
                            </div>
                            <div class="d-flex flex-wrap">
                                <div v-for="date in configurations[bookingType]['not_available_delivery_dates']">
                                    <span class="mr-3">{{ date }}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Route planning next day cut-off</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-center" v-for="zoneData in zones">
                                    <div class="mr-2"><b>{{ zoneData.label }}</b></div>
                                    <div class="">
                                        <vue-timepicker
                                            manual-input
                                            placeholder=""
                                            v-model="configurations[bookingType][`route_planning_cut_off_time${zoneData.prefix}`]"
                                            input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                        </vue-timepicker>
                                        <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.route_planning_cut_off_time${zoneData.prefix}`]">
                                            {{ errors[`configurations.${bookingType}.route_planning_cut_off_time${zoneData.prefix}`][0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div>
                                <strong>Default</strong> route planning next day cut-off
                            </div>
                            <div>
                                (system default setting)
                            </div>
                        </td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-center" v-for="zoneData in zones">
                                    <div class="mr-2"><b>{{ zoneData.label }}</b></div>
                                    <div class="">
                                        <vue-timepicker
                                            manual-input
                                            placeholder=""
                                            v-model="configurations[bookingType][`default_route_planning_cut_off_time${zoneData.prefix}`]"
                                            input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                        </vue-timepicker>
                                        <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.default_route_planning_cut_off_time${zoneData.prefix}`]">
                                            {{ errors[`configurations.${bookingType}.default_route_planning_cut_off_time${zoneData.prefix}`][0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-5">
            <div class="h4">AUTOPUSH DELIVERY DAY</div>
            <div>
                <table class="table table-bordered table-striped" aria-label="Autopush table">
                    <tr>
                        <td style="width: 34%;">When customer adds a time-variable service</td>
                        <td v-for="bookingType in bookingTypes" style="width: 33%;">
                            <div class="d-flex align-items-center mb-4" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="flex-grow-1">
                                <div class="d-flex align-items-center justify-content-center">
                                    <input
                                        class="form-control small-input mr-3"
                                        type="text"
                                        id="days-autopush-budget"
                                        v-model="configurations[bookingType][`days_autopush${addressType['postfix']}`]"
                                    >
                                    <label for="days-autopush-budget" class="mb-0">Days autopush</label>
                                </div>
                                <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.days_autopush${addressType['postfix']}`]">
                                    {{ errors[`configurations.${bookingType}.days_autopush${addressType['postfix']}`][0] }}
                                </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="mt-5">
            <button class="btn btn-primary" @click="save">Save configurations</button>
        </div>
    </div>

</template>

<script>
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import moment from "moment/moment";
export default {
    name: "Configurations",
    components: {VueTimepicker, DatePicker},
    mixins: [datePickerOptionsMixin],
    props: {
        configurationsProp: {type: Array, required: true},
        bookingFlex: {type: String, required: true},
        bookingAdHoc: {type: String, required: true},
        bookingNameFlex: {type: String, required: true},
        bookingNameAdHoc: {type: String, required: true},
        today: {type: String, required: true},
        tomorrow: {type: String, required: true},
        dayAfterTomorrow: {type: String, required: true},
    },
    data() {
        return {
            configurations: {
                0: {},
                3: {permits: [], shorter_time_intervals: [], shorter_time_intervals_pickup: [], sms_flow_price_intervals: [], sms_flow_price_intervals_pickup: []},
                4: {permits: [], shorter_time_intervals: [], shorter_time_intervals_pickup: [], sms_flow_price_intervals: [], sms_flow_price_intervals_pickup: []}
            },
            errors: {},
            bookingTypes: [this.bookingFlex, this.bookingAdHoc],
            addressTypes: {
                pickup: {label: 'Pickup', postfix: '_pickup'},
                dropoff: {label: 'Dropoff', postfix: ''}
            },
            zones: [
                {
                    zone: 'all',
                    label: 'Rest zones',
                    prefix: ''
                },
                {
                    zone: 1,
                    label: 'Zone 1',
                    prefix: '_zone_1'
                }
            ],

        }
    },
    created() {
        let value;
        for (let i in this.configurationsProp) {
            value = this.configurationsProp[i]['value'];
             if('permits' === this.configurationsProp[i]['name']) {
                if (value) {
                    value = JSON.parse(value);
                    value = value.join('; ');
                }

            } else if (this.configurationsProp[i]['name'].includes('send_sms_on_test_number')) { // boolean
                value = value && value === '1';

            } else if (this.configurationsProp[i]['name'].includes('not_available_delivery_dates') ||
                this.configurationsProp[i]['name'].includes('driver_fees_fees_bonuses') ||
                this.configurationsProp[i]['name'].includes('shorter_time_intervals') ||
                this.configurationsProp[i]['name'].includes('sms_flow_price_intervals')
            ) {
                value = value ? JSON.parse(value) : [];
            }

            this.$set(
                this.configurations[this.configurationsProp[i]['booking_type']],
                this.configurationsProp[i]['name'],
                value
            );

            if (this.configurationsProp[i]['name'] === 'not_available_delivery_dates') {
                this.onDateChange('', this.configurationsProp[i]['booking_type']);
            }
        }
    },
    methods: {
        save() {
            this.errors = {};
            let val;
            let data = JSON.parse(JSON.stringify(this.configurations));
            let addressType;
            for (let bookingType in data) {
                for (let j in this.addressTypes) {
                    addressType = this.addressTypes[j];

                    if (data[bookingType][`sms_flow_cut_off_day${addressType['postfix']}`] &&
                        data[bookingType][`sms_flow_cut_off_day${addressType['postfix']}`]['name']
                    ) {
                        this.$set(
                            data[bookingType],
                            `sms_flow_cut_off_day${addressType['postfix']}`,
                            data[bookingType][`sms_flow_cut_off_day${addressType['postfix']}`]['name']
                        );
                    }
                }

                if (data[bookingType].permits) {
                    val = data[bookingType].permits.split(';');
                    if (val.length) {
                        data[bookingType].permits = val.map((item) => {return item.trim()})
                    }
                }
            }
            axios.post(`/configurations`, {configurations: data})
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: `Saved successfully!`,
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                }).catch((err) => {
                this.flashError(err, ``);
            });
        },
        addShorterTimeInterval(bookingType, addressTypeIndex) {
            this.configurations[bookingType][`shorter_time_intervals${this.addressTypes[addressTypeIndex]['postfix']}`].push({
                from: '00:00',
                to: '00:00',
                price: '0',
            });
        },

        removeShorterTimeInterval(bookingType, index, addressTypeIndex) {
            this.configurations[bookingType][`shorter_time_intervals${this.addressTypes[addressTypeIndex]['postfix']}`].splice(index, 1);
        },
        addSmsFlowPriceInterval(bookingType, addressTypeIndex) {
            this.configurations[bookingType][`sms_flow_price_intervals${this.addressTypes[addressTypeIndex]['postfix']}`].push({
                from: '00:00',
                to: '00:00',
                percentage: '0',
            });
        },

        removeSmsFlowPriceInterval(bookingType, index, addressTypeIndex) {
            this.configurations[bookingType][`sms_flow_price_intervals${this.addressTypes[addressTypeIndex]['postfix']}`].splice(index, 1);
        },
        flashError(error) {
            let er = error.response.data || error.response;
            console.error(er);
            this.flashMessage.error({
                title: '',
                message: error.response.data.message || error.response.data ||  'Error',
                time: 3000,
                blockClass: 'flash-message error'
            });

            if (error.response.data.errors) {
                this.errors = error.response.data.errors;
            }
        },
        changeOption() {
            const conf = JSON.parse(JSON.stringify(this.configurations));
            this.configurations = {};
            this.configurations = conf;
        },
        disabledDates(date) {
            const startFrom = moment().toDate();
            startFrom.setHours(0, 0, 0, 0);

            return date < startFrom ||
                date > new Date(
                    startFrom.getTime() + 365 * 24 * 3600 * 1000) ||
                [0,6].includes(date.getDay())
        },
        onDateChange(e, bookingType) {
            const startFrom = moment().toDate();
            startFrom.setHours(0, 0, 0, 0);
            let sorted = this.configurations[bookingType]['not_available_delivery_dates'].sort((a, b) => {
                return moment(a, 'DD-MM-YYYY') - moment(b, 'DD-MM-YYYY');
            });
            let removeIndexes = [];
            let d;
            sorted.forEach((date, index) => {
                d = moment(date, 'DD-MM-YYYY')
                if (date < startFrom) {
                    removeIndexes.push(index);
                }
            });

            let n = 0;
            if (removeIndexes.length) {
                removeIndexes.forEach(i => {
                    sorted.splice((i - n), 1);
                    n++;
                });
            }
            this.$set(this.configurations[bookingType], 'not_available_delivery_dates', sorted);
        },
        clearDates(e, bookingType) {
            this.$set(this.configurations[bookingType], 'not_available_delivery_dates', []);
        },
    }
}
</script>

<style scoped>
.vue__time-picker {
    width: auto !important;
}
.time-picker input {
    margin-left: 0;
}

tr th:not(:first-child),
tr td:not(:first-child) {
    text-align: center;
}

.small-input {
    max-width: 140px;
}

.vue__time-picker input.display-time {
    border-radius: 0.25rem;
}

table td.vertical-align-top {
    vertical-align: top;
}
.address-type-label {
    min-width: 60px;
    text-align: left;
}

.bold-font {
    font-weight: bold;
    font-size: 1.1rem;
}

</style>
